import { GetOrderResponse, CreateOrderResponse } from '../../models/rest/order';
import { OrderData, CgGroupingLevel } from '../../models/sizing-group';

/**
 * Order Adapter
 *
 * Transforms REST API order responses (snake_case) to MobX store format (camelCase).
 *
 * Naming convention: mapRest{Type}ToStore{Type}
 *
 * These adapters are pure functions with no side effects - they only transform data.
 */

/**
 * Maps REST order response to store OrderData format
 *
 * Transformations:
 * - snake_case → camelCase field names
 * - cg_grouping_level (number) → groupingLevel (CgGroupingLevel enum)
 * - enable_box (boolean) → enableBox (boolean)
 *
 * @param restOrder REST API order response (GetOrderResponse or CreateOrderResponse)
 * @returns OrderData in store format
 */
export function mapRestOrderToStoreOrder(restOrder: GetOrderResponse | CreateOrderResponse): OrderData {
  return {
    groupingLevel: numberToCgGroupingLevel(restOrder.cg_grouping_level),
    enableBox: restOrder.enable_box,
  };
}

/**
 * Converts numeric CG grouping level to CgGroupingLevel enum
 *
 * @param level Numeric CG level (3, 4, or 5)
 * @returns CgGroupingLevel enum value
 */
function numberToCgGroupingLevel(level: number): CgGroupingLevel {
  switch (level) {
    case 3:
      return CgGroupingLevel.CG3;
    case 4:
      return CgGroupingLevel.CG4;
    case 5:
      return CgGroupingLevel.CG5;
    default:
      return CgGroupingLevel.CG3; // Default fallback
  }
}
